<template>
    <div
        class="img_filter"
    >
        <span class="img_filter-name">{{ filter.title }}</span>
        <input
            type="range"
            class="filter_slide"
            :min="filter.min"
            :max="filter.max"
            v-model="filterValue"
            @input="onInputHandler"
        >
        <span v-text="filterValue" class="img_filter-value"></span>
    </div>   
</template>

<script>
    import { mapGetters } from 'vuex';

    export default {
        data() {
            return {
                filterValue: null
            }
        },
        methods: {
            onInputHandler() {
                let filterName = this.filter.name;
                let filterValue = this.filterValue;

                let payload = {
                    filterName: filterName,
                    filterValue: filterValue
                }

                this.$store.dispatch('EDIT_IMAGE_ELEMENT_FILTERS', payload)
            }
        },
        computed: {
            ...mapGetters([
                'activeElement',
                'getActiveElement'
            ])
        },
        mounted() {
            this.filterValue = this.getActiveElement.filters[this.filter.name].value
        },
        props: ['filter']
    }
</script>

<style lang="scss" scoped>
    .img_filter {
        padding: 8px 0;
        display: flex;
        align-items: center;
    }
    .img_filter-name {
        width: 45%;
    }
    .img_filter-value {
        width: 15%;
        text-align: right;
    }
    .filter_slide {
        -webkit-appearance: none;
        width: 100%;
        height: 6px;
        background: #ffffff;
        border-radius: 3px;
        border: 1px solid #D4D4D4;
        outline: none;
        opacity: 0.7;
        -webkit-transition: .2s;
        transition: opacity .2s;
    }
    .filter_slide:hover {
        opacity: 1;
    }
    .filter_slide::-webkit-slider-thumb {
        -webkit-appearance: none;
        appearance: none;
        border-radius: 50%;
        width: 12px;
        height: 12px;
        background: #737373;
        cursor: pointer;
    }
    .filter_slide::-moz-range-thumb {
        width: 12px;
        height: 12px;
        border-radius: 50%;
        background: #737373;
        cursor: pointer;
    }
</style>